import React from "react";
import { MdClose } from "react-icons/md";

const LogoPreviewModal = ({ isOpen, onClose, imageUrl, imageName }) => {
  if (!isOpen) return null; // ⬅ prevents modal from showing when closed

  return (
    <div className="modal-overlay">
      <div
        className="modal-content-admin"
        style={{ backgroundColor: "#E5E7E9" }}
      >
        <div className="modal-header">
          <h6>Logo Preview</h6>
          <button className="close-btn" onClick={onClose}>
            <MdClose />
          </button>
        </div>

        <div className="modal-body">
          {imageUrl ? (
            <div>
              <img
                src={imageUrl}
                alt="Logo Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
              <p className="mt-2 text-muted">
                {imageName.length > 20
                  ? imageName.substring(0, 20) + "..."
                  : imageName}
              </p>
            </div>
          ) : (
            <p>No image to preview</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogoPreviewModal;
